import React from "react";
import AnonymousPage from "@/models/base/AnonymousPage";
import {
	Form,
	PageContainer,
	PageHeader,
} from "@reapptor-apps/reapptor-react-components";
import ReactMarkdown from "react-markdown";
import styles from "./PrivacyPolicy.module.scss";
import Localizer from "@/localization/Localizer";
import {DynamicPageData, DynamicPageResponseSingleType} from "@/models/cms/DynamicPageResponse";


export interface IPrivacyPolicyParams {}
interface IPrivacyPolicyState {
	privacyPolicy: DynamicPageData | null;
}

export default class PrivacyPolicy extends AnonymousPage {

	state: IPrivacyPolicyState = {
		privacyPolicy: null
	};


	public formRef: React.RefObject<Form> = React.createRef();

	async initializeAsync(): Promise<void> {
		await super.initializeAsync();
		const response: DynamicPageResponseSingleType = await this.getAsync(
			"/api/Application/GetDynamicPageContent?contentType=privacy-policy&populate=*"
		);
		await this.setState({privacyPolicy: response.data});
		window.scrollTo(0, 0);
	}


	public render(): React.ReactNode {

		return (
			<PageContainer fullWidth className={styles.pageContainer}>
				<PageHeader className={styles.pageHeader} title={Localizer.companyPagePrivacyPolicy}/>
				<div className={styles.pageContent}>
					<div className={styles.fluidContent}>
						{this.state.privacyPolicy && (
							<ReactMarkdown>{this.state.privacyPolicy.attributes.content}</ReactMarkdown>
						)}
					</div>
				</div>
			</PageContainer>
		);
	}
}